import * as yup from 'yup';
import { holdingCompanyFormFields } from '../../fields/formFields';

export const holdingCompanyFormSchema = yup.object({
  [holdingCompanyFormFields.nameEn]: yup
    .string()
    .max(150, 'Name En must be at most 150 characters')
    .required('Name En is required')
    .trim(),
  [holdingCompanyFormFields.nameAr]: yup.string().max(150, 'Name Ar must be at most 150 characters').nullable(),
  [holdingCompanyFormFields.ticker]: yup.string().max(20, 'Ticker must be at most 20 characters').nullable(),
  [holdingCompanyFormFields.website]: yup.string().max(255, 'Website must be at most 255 characters').nullable(),
  [holdingCompanyFormFields.logoUrl]: yup.string().nullable(),
});
